/**
 * Copies values from `source` into the form and revalidates the fields that got a value.
 *
 * Fields are matched BY NAME: `fieldNames` accepts only the names that exist in both the source and the form, and
 * each one is read and written under that same name. There is no mapping here by design — when the source names a
 * field differently, rename it in an object of your own before calling, and pass that object as `source`:
 *
 * @example
 * fillFormFields({
 * 	source: { carrierInn: legal.inn, carrierName: legal.name },
 * 	fieldNames: ['carrierInn', 'carrierName'],
 * 	setValue,
 * 	trigger,
 * });
 */
export const fillFormFields = ({ source, fieldNames, setValue, trigger, }) => {
    const fieldsToTrigger = [];
    fieldNames.forEach((fieldName) => {
        const newValue = (source[fieldName] ?? null);
        setValue(fieldName, newValue);
        if (newValue !== undefined && newValue !== null && newValue !== '') {
            fieldsToTrigger.push(fieldName);
        }
    });
    // Force trigger Yup validation to clear active error banners instantly
    trigger?.(fieldsToTrigger);
};
